import { Injectable } from '@angular/core';
import { clientTrade, Trade } from '../_models/trade';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { UserData } from '../admin/reports/reports.component';

const baseUrl = `${environment.apiUrl}/orbit`;
@Injectable({
  providedIn: 'root'
})
export class OrbitService {

  constructor(private http: HttpClient) { }

  register(payload:any){
    const formData = new FormData();
    formData.append('bankname', payload.bankname);
    formData.append("address",payload.address);
    formData.append("country",payload.country);   
    formData.append('zipcode', payload.zipcode);
    formData.append("phonenumber",payload.phonenumber);  
    return this.http.post(`${baseUrl}/register`, payload)
  }
  preorder(payload:any){ 
    return this.http.post(`${baseUrl}/preorder`, payload)
  }

  getAllorbitclients() {
    return this.http.get<any[]>(`${baseUrl}/all-orbitclients`);
  }

  getOrbitClientDetails(orbitId:any){
    return this.http.post(`${baseUrl}/get-orbitclients`,{_id :orbitId })
  }

  searchreport(payload: any): Observable<{ data: UserData[] }> {
    return this.http.post<{ data: UserData[] }>(`${baseUrl}/searchreport`, payload);
  }
  getOrderbyid(orderid:any){
    return this.http.post(`${baseUrl}/getorderbyid`,{_id :orderid })
  }
  updatepreorderlist(orderid:any, data:any){
    console.log('updatepreorderlist',orderid,data)
    return this.http.put(`${baseUrl}/updatepreorderlist?id=`+orderid,data)
  }
  getordersByCustomerId(clientid: any): Observable<clientTrade[]> {
    return this.http.post<clientTrade[]>(`${baseUrl}/getordersByCustomerId`, {
      customerid: clientid
    });
  }
  updateOrbitClientDetails(orbitId:any, data:any){
    return this.http.put(`${baseUrl}/update-orbitclients?id=`+orbitId, data)
  }
  shareLink(data:any){
    return this.http.post(`${baseUrl}/sharelink`, data)
  }


}
